import PropTypes from 'prop-types'
import { useTranslation } from '@mc/i18n'
import Amazon from './Amazon'
import Apple from './Apple'
import Google from './Google'
import Roku from './Roku'

const components = {
  amazon: Amazon,
  apple: Apple,
  google: Google,
  roku: Roku,
}

const AppStore = ({ kind, ...restProps }) => {
  const { t } = useTranslation('@mc/next')

  const Component = components[kind]
  const altTexts = {
    amazon: t('store.amazon'),
    apple: t('store.apple'),
    google: t('store.google'),
    roku: t('store.roku'),
  }
  const altText = altTexts[kind]

  return (
    <>
      <span className='mc-sr-only'>{altText}</span>
      <Component {...restProps} />
    </>
  )
}

AppStore.propTypes = {
  kind: PropTypes.oneOf(['amazon', 'apple', 'google', 'roku']),
}

export default AppStore
